import React, { PropsWithChildren, PureComponent } from 'react';
import { LeftCircleFilled } from '@ant-design/icons';
import { Flex } from './Flex';
import ConditionalRender from 'app/common/components/ConditionalRender';

interface SidePanelSeparatorProps {
    onHideSidePanel?: () => void;
    hideSeparator?: boolean;
}

export class SidePanelSeparator extends PureComponent<PropsWithChildren<SidePanelSeparatorProps>> {
    handleHideSidePanel = () => {
        this.props.onHideSidePanel?.();
    };
    render() {
        const { children = <LeftCircleFilled /> } = this.props;

        return (
            <Flex
                size="5em"
                style={{
                    position: 'relative',
                    margin: '1em 1em',
                    background:
                        'linear-gradient(90deg, #00000000, #00000000 47%, #464646 49%, #464646 51%, #00000000 53%, #00000000 100%)',
                }}>
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        fontSize: '2.5em',
                        cursor: 'pointer',
                    }}
                    onClick={this.handleHideSidePanel}>
                    <ConditionalRender condition={!this.props.hideSeparator}>{children}</ConditionalRender>
                </div>
            </Flex>
        );
    }
}
